export const phoneCodes = [
  { country: 'France', code: '+33', flag: '🇫🇷' },
  { country: 'United States', code: '+1', flag: '🇺🇸' },
  { country: 'United Kingdom', code: '+44', flag: '🇬🇧' },
  { country: 'Germany', code: '+49', flag: '🇩🇪' },
  { country: 'Spain', code: '+34', flag: '🇪🇸' },
  { country: 'Italy', code: '+39', flag: '🇮🇹' },
  { country: 'Netherlands', code: '+31', flag: '🇳🇱' },
  { country: 'Belgium', code: '+32', flag: '🇧🇪' },
  { country: 'Switzerland', code: '+41', flag: '🇨🇭' },
  { country: 'Austria', code: '+43', flag: '🇦🇹' },
  { country: 'Portugal', code: '+351', flag: '🇵🇹' },
  { country: 'Poland', code: '+48', flag: '🇵🇱' },
  { country: 'Czech Republic', code: '+420', flag: '🇨🇿' },
  { country: 'Hungary', code: '+36', flag: '🇭🇺' },
  { country: 'Romania', code: '+40', flag: '🇷🇴' },
  { country: 'Bulgaria', code: '+359', flag: '🇧🇬' },
  { country: 'Greece', code: '+30', flag: '🇬🇷' },
  { country: 'Croatia', code: '+385', flag: '🇭🇷' },
  { country: 'Slovenia', code: '+386', flag: '🇸🇮' },
  { country: 'Slovakia', code: '+421', flag: '🇸🇰' },
  { country: 'Lithuania', code: '+370', flag: '🇱🇹' },
  { country: 'Latvia', code: '+371', flag: '🇱🇻' },
  { country: 'Estonia', code: '+372', flag: '🇪🇪' },
  { country: 'Finland', code: '+358', flag: '🇫🇮' },
  { country: 'Sweden', code: '+46', flag: '🇸🇪' },
  { country: 'Norway', code: '+47', flag: '🇳🇴' },
  { country: 'Denmark', code: '+45', flag: '🇩🇰' },
  { country: 'Iceland', code: '+354', flag: '🇮🇸' },
  { country: 'Ireland', code: '+353', flag: '🇮🇪' },
  { country: 'Luxembourg', code: '+352', flag: '🇱🇺' },
  { country: 'Monaco', code: '+377', flag: '🇲🇨' },
  { country: 'Canada', code: '+1', flag: '🇨🇦' },
  { country: 'Australia', code: '+61', flag: '🇦🇺' },
  { country: 'New Zealand', code: '+64', flag: '🇳🇿' },
  { country: 'Japan', code: '+81', flag: '🇯🇵' },
  { country: 'South Korea', code: '+82', flag: '🇰🇷' },
  { country: 'China', code: '+86', flag: '🇨🇳' },
  { country: 'India', code: '+91', flag: '🇮🇳' },
  { country: 'Singapore', code: '+65', flag: '🇸🇬' },
  { country: 'Hong Kong', code: '+852', flag: '🇭🇰' },
  { country: 'Taiwan', code: '+886', flag: '🇹🇼' },
  { country: 'Thailand', code: '+66', flag: '🇹🇭' },
  { country: 'Malaysia', code: '+60', flag: '🇲🇾' },
  { country: 'Indonesia', code: '+62', flag: '🇮🇩' },
  { country: 'Philippines', code: '+63', flag: '🇵🇭' },
  { country: 'Vietnam', code: '+84', flag: '🇻🇳' },
  { country: 'Brazil', code: '+55', flag: '🇧🇷' },
  { country: 'Argentina', code: '+54', flag: '🇦🇷' },
  { country: 'Chile', code: '+56', flag: '🇨🇱' },
  { country: 'Colombia', code: '+57', flag: '🇨🇴' },
  { country: 'Mexico', code: '+52', flag: '🇲🇽' },
  { country: 'Peru', code: '+51', flag: '🇵🇪' },
  { country: 'Venezuela', code: '+58', flag: '🇻🇪' },
  { country: 'Ecuador', code: '+593', flag: '🇪🇨' },
  { country: 'Uruguay', code: '+598', flag: '🇺🇾' },
  { country: 'Paraguay', code: '+595', flag: '🇵🇾' },
  { country: 'Bolivia', code: '+591', flag: '🇧🇴' },
  { country: 'Russia', code: '+7', flag: '🇷🇺' },
  { country: 'Ukraine', code: '+380', flag: '🇺🇦' },
  { country: 'Belarus', code: '+375', flag: '🇧🇾' },
  { country: 'Kazakhstan', code: '+7', flag: '🇰🇿' },
  { country: 'Turkey', code: '+90', flag: '🇹🇷' },
  { country: 'Israel', code: '+972', flag: '🇮🇱' },
  { country: 'Saudi Arabia', code: '+966', flag: '🇸🇦' },
  { country: 'United Arab Emirates', code: '+971', flag: '🇦🇪' },
  { country: 'Qatar', code: '+974', flag: '🇶🇦' },
  { country: 'Kuwait', code: '+965', flag: '🇰🇼' },
  { country: 'Bahrain', code: '+973', flag: '🇧🇭' },
  { country: 'Oman', code: '+968', flag: '🇴🇲' },
  { country: 'Jordan', code: '+962', flag: '🇯🇴' },
  { country: 'Lebanon', code: '+961', flag: '🇱🇧' },
  { country: 'Syria', code: '+963', flag: '🇸🇾' },
  { country: 'Iraq', code: '+964', flag: '🇮🇶' },
  { country: 'Iran', code: '+98', flag: '🇮🇷' },
  { country: 'Afghanistan', code: '+93', flag: '🇦🇫' },
  { country: 'Pakistan', code: '+92', flag: '🇵🇰' },
  { country: 'Bangladesh', code: '+880', flag: '🇧🇩' },
  { country: 'Sri Lanka', code: '+94', flag: '🇱🇰' },
  { country: 'Nepal', code: '+977', flag: '🇳🇵' },
  { country: 'Myanmar', code: '+95', flag: '🇲🇲' },
  { country: 'Cambodia', code: '+855', flag: '🇰🇭' },
  { country: 'Laos', code: '+856', flag: '🇱🇦' },
  { country: 'South Africa', code: '+27', flag: '🇿🇦' },
  { country: 'Egypt', code: '+20', flag: '🇪🇬' },
  { country: 'Nigeria', code: '+234', flag: '🇳🇬' },
  { country: 'Kenya', code: '+254', flag: '🇰🇪' },
  { country: 'Ghana', code: '+233', flag: '🇬🇭' },
  { country: 'Morocco', code: '+212', flag: '🇲🇦' },
  { country: 'Tunisia', code: '+216', flag: '🇹🇳' },
  { country: 'Algeria', code: '+213', flag: '🇩🇿' },
  { country: 'Libya', code: '+218', flag: '🇱🇾' },
  { country: 'Sudan', code: '+249', flag: '🇸🇩' },
  { country: 'Ethiopia', code: '+251', flag: '🇪🇹' },
  { country: 'Uganda', code: '+256', flag: '🇺🇬' },
  { country: 'Tanzania', code: '+255', flag: '🇹🇿' },
  { country: 'Rwanda', code: '+250', flag: '🇷🇼' },
  { country: 'Zambia', code: '+260', flag: '🇿🇲' },
  { country: 'Zimbabwe', code: '+263', flag: '🇿🇼' },
  { country: 'Botswana', code: '+267', flag: '🇧🇼' },
  { country: 'Namibia', code: '+264', flag: '🇳🇦' },
  { country: 'Madagascar', code: '+261', flag: '🇲🇬' },
  { country: 'Mauritius', code: '+230', flag: '🇲🇺' },
  { country: 'Seychelles', code: '+248', flag: '🇸🇨' }
].sort((a, b) => {
  // Put France first
  if (a.country === 'France') return -1;
  if (b.country === 'France') return 1;
  // Then sort alphabetically
  return a.country.localeCompare(b.country);
});